module.exports = __webpack_public_path__ + "img/avatar1.61953c33.png";